import React, { useRef, useState } from 'react'
import { addTransaction } from '../firebase-services/db-services'
import handleChange from '../Utils/HandleChange';
import { FormInput, FormRow, RadioButtonGroup } from './Controls/Input';
import Select from './Controls/Select';
import { intitalTransactionForm, materialsList, unitList } from '../Data/Constants';
import GetTimeStamp from '../Utils/GetTimeStamp';
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionsFetch } from '../Redux/slices/transactionState';
import ScrollToTargetAdjusted from '../Utils/ScrollToTargetAdjusted';
import {  toast } from 'react-toastify';
import {  selectPartyList } from '../Redux/slices/partyState';
import { selectDriverList } from '../Redux/slices/driverState';
import { selectVehicleList } from '../Redux/slices/vehicleState';

export default function AddTransactions() {
  const formRef = useRef(null)
    const dispatch = useDispatch()
    const parties = useSelector(selectPartyList)
    const drivers = useSelector(selectDriverList)
    const vehicles = useSelector(selectVehicleList)
    
    const [form, setForm] = useState(intitalTransactionForm)
    const changeHandler = handleChange(form, setForm)

    const submitHandler = (e) => {
      e.preventDefault()
      form.date = GetTimeStamp(form.date)
      console.log("payment_type:",form.payment_type)
      addTransaction(form).then(res=>{
        dispatch(getTransactionsFetch())
        formRef.current.reset()
        ScrollToTargetAdjusted('transactionTable')
        toast.success("Record added successfully")
      }).catch(e=>{
        console.log(e)
        toast.error("Failed to add Record")
      })
    }
    
    return (
      <div id='addTransactionForm' className="bg-gray-100 p-8 rounded-md mx-auto my-36 w-full max-w-7xl">
        <form ref={formRef} className='w-full'>
          <h1 className='text-2xl sm:text-3xl md:text-4xl font-bold tracking-wide mb-7'>Add New Record</h1>
          <FormRow mx={3}>
            <FormInput name='date' type="datetime-local" label='Date' onChange={changeHandler} />
            <Select name='party_name' label='Party Name' placeholder='Select Party Name' options={parties} onChange={changeHandler} />
          </FormRow>
          <FormRow mx={3}>
            <Select name='material' label='Material' placeholder='Select Material' options={materialsList} onChange={changeHandler} />
            <FormInput name='quality' label='Material Quality' onChange={changeHandler} placeholder="Material Quality" />
  
          </FormRow>
          <FormRow mx={3}>
            <FormInput name='quantity' min="0"  type='number' label='Quantity' placeholder="Material Quantity"  onChange={changeHandler} />
            <Select name='unit' label='Unit' options={unitList} placeholder="Select Unit" onChange={changeHandler} />
          </FormRow>
          <FormRow mx={3}>
            <FormInput name='from' label='From' placeholder='From Location' onChange={changeHandler} />
            <FormInput name='to' type='text' label='To' placeholder='To Location' onChange={changeHandler} />
          </FormRow>
          <FormRow mx={3}>
            <FormInput name='supplier_name' label='Supplier Name' placeholder='Supplier Name' onChange={changeHandler} />
            <Select name='vehicle' type='text' label='Vehicle Name' placeholder='Select Vehicle Name' options={vehicles} onChange={changeHandler} />
          </FormRow>
          <FormRow mx={3}>
            <Select name='driver' label='Driver Name' placeholder='Select Driver Name' options={drivers} onChange={changeHandler} />
            <FormInput name='labour' type='text' label='Labour Name' placeholder='Labour Name' onChange={changeHandler} />
          </FormRow>
          <FormRow mx={3}>
            <FormInput name='bill' type='number' min="0" label='Bill Amount' placeholder='Bill Amount' onChange={changeHandler} />
            <FormInput name='paid' type='number' min="0" label='Bill Paid' placeholder='Bill Paid' onChange={changeHandler} />
          </FormRow>
          <RadioButtonGroup label='Payment type' name='payment_type' options={["Cash", "Credit"]} onChange={changeHandler} />
          <FormRow mx={3}>
            <FormInput name='book_no' type='text' label='Book No' placeholder='Book No' onChange={changeHandler} />
            <FormInput name='slip_no' type='text' label='Slip No' placeholder='Slip No' onChange={changeHandler} />
          </FormRow>
          <FormRow mx={3}>
            <FormInput name='party_sig' type='text' label='Party Sig' placeholder='Party Sig' onChange={changeHandler} />
            <FormInput name='remark' type='text' label='Remarks' placeholder='Any Remarks' onChange={changeHandler} />
          </FormRow>
  
          <div className='flex flex-row gap-4'>
            <button
              className="hover:bg-[#4f48ee] rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
              onClick={submitHandler}
            >
              Submit
            </button>
            <input type="reset"
              className="hover:bg-gray-600 cursor-pointer rounded-md bg-gray-500 py-3 px-8 text-center text-base font-semibold text-white outline-none"
            />
          </div>
        </form>
      </div>
    )
  }